import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles/fullEpgPersistance.css';
import '../Resume/resume.css';
import EpgController from '../../AAF/Nepg/EpgController';
import LocalStorage from '../DeviceStorage/LocalStorage';
import FlagEventMini from '../PersistentMiniEpg/FlagEventMini';
import EpgPersistence from '../../AAF/Nepg/EpgPersistence';
import Utils from '../../utils/Utils';
import { HidePlayerControlsObserver } from '../PersistentMiniEpg/MiniObserver';
import { showPassEventNotAvailableNotification, showFutureEventNotAvailableNotification } from '../../actions/notification';
import { connect } from 'react-redux';
import ModalEpgUtils from '../Epg/ModalEpgUtils';
import ChannelSingleton from '../Epg/ChannelsSingleton';
import * as EpgEventUtils from '../Epg/EpgEventUtils';
import { playCatchupEvent } from '../../actions/playmedia'
import AnalyticsDimensionSingleton from '../Header/AnalyticsDimensionSingleton';
import channelStreamUtil from '../../utils/ChannelStreamUtil';
import EpgConstants from '../../AAF/Nepg/EpgConstants';
import PlayerStreamingUtils from '../../utils/PlayerStreamingUtils';
import TvChannelUtil from '../../utils/TvChannelUtil';
import PlayerControlsLogic from 'src/playerDomain/components/PlayerControlsLogic';
import logger from 'src/utils/logger/logger';

class FullEpgPersistance extends Component {
  constructor(props) {
    super(props);
    this.playerStreamingUtils = new PlayerStreamingUtils();
    this.state = {
      hasError: false
    };
  }

  componentWillMount = () => {
  };

  onClickPassEvent = (event) => {
    if(EpgEventUtils.canPlayPastEventAsCatchup(event)){
      this.props.playCatchupEvent(event);
    }
    else{
      this.props.showPassEventNotAvailableNotification();
    }
  }

  sendMetric = (label) =>{
    this.props && this.props.setMetricsEvent && this.props.setMetricsEvent({
      hitType: 'event',
      eventCategory: 'guia de programación',
      eventAction: 'click',
      eventLabel: label,
    });
    this.props && this.props.setMetricsEvent && this.props.setMetricsEvent({ type: 'executor'});

    const payload=new AnalyticsDimensionSingleton().getPayload();
    this.props && this.props.setMetricsEvent && this.props.setMetricsEvent(payload);
    this.props && this.props.setMetricsEvent && this.props.setMetricsEvent({ type: 'executor'});

  }

  onClickCurrentEvent = event => {
    this.props.hideEpgOutside(event.group_id);

    // se envia la metrica
    if(event && event.group_id){
      const channelInfo = channelStreamUtil.get(event.group_id);
      const label = `${channelInfo && channelInfo.title || ''} / ${event && event.name || ''}`;
      this.sendMetric(label)
    }
  }

  onClickFutureEvent = event => {
    const handleBluePress = (fromEpg = false) => {
      FlagEventMini.setFromNot(true);
      setTimeout(() =>{
        ModalEpgUtils.blueHandler({
          hideEpgOutsideCb: null,
          handleGuideCb:null,
          data: event,
          streamType: this.props.streamType,
          streamContentType: this.props.streamContentType(),
          changeLangCb: this.props.changeLangCb,
          from: fromEpg ? EpgConstants.FROM_FULL_EPG : null,
          showFullEpg: fromEpg ? this.props && this.props.showFullEpg || null :  null
        });
      }, 300);
    }

    this.props.showFutureEventNotAvailableNotification(handleBluePress);
  }

  onClicEvent = async (isCurrent, isPastEvent, isFutureEvent, event) => {
    if(!event.group_id) return;
    if(typeof this.props.hideEpgOutside === 'function'){
      this.props.hideEpgOutside();
    }

    const isSusc = await this.playerStreamingUtils.checkSusc(null, event.group_id, (typeof this.props.handleGuide === 'function' ? this.props.handleGuide : ()=>{}));

    if(isSusc){
      if(isPastEvent){
        this.onClickPassEvent(event);
      }
      else if(isCurrent){
        this.onClickCurrentEvent(event);
      }
      else if(isFutureEvent){
        this.onClickFutureEvent(event);
      }
      FlagEventMini.setFromMini(true);
    }
  };

  componentDidMount = () => {
    PlayerControlsLogic.setValueStatePlaying({fullEPG: true});

    Utils.hideSkipIntro();
    const loadObject = {
      group_id: null,
      filter_id: null
    };
    EpgController.initialise('fullepgcontainer',{
      getCurrentEvent: this.props.getCurrentEvent,
      getContenStreamType: this.props.streamContentType
    }).then(() => {
      loadObject.group_id = TvChannelUtil.getLastChannel() || null;
      if (
        this.props &&
        this.props.filterEpg &&
        typeof this.props.filterEpg === 'object' &&
        this.props.filterEpg.id
      ) {
        loadObject.filter_id = this.props.filterEpg.id;
      }

      if (loadObject.filter_id) {
        loadObject.group_id = null;
      }
      EpgController.activate(loadObject, true);
      EpgController.enableInterceptor();
      EpgController.setYellowButton(this.props.yellowHandler);
      EpgController.setHandleRed(this.props.redHandler);
      EpgController.setBlueButton(this.props.blueHandler);

      EpgController.setRefChannel(this.props.refChannel);
      EpgController.setOnClickEventCallback(this.onClicEvent);
      EpgController.setOnRecEventCallback(this.props.record);
      EpgController.setOutside(this.props.hideEpgOutside);
      EpgController.setHandleMosaic(this.props.handleMosaic);
      EpgController.setHandleGuide(this.props.handleGuide);
      EpgController.setClearTimeoutAutoHide(this.props.clearTimeoutAutoHide);
      EpgController.setAutoHideTimeout(this.props.setAutoHideTimeout);

      // EpgController.setResume(this.props.setResume);
    });
  };

  componentWillReceiveProps = nextProps => {
    if (this.props.nodeId !== nextProps.nodeId) {
      const loadObject = {
        group_id: null,
        filter_id: nextProps.nodeId
      };
      EpgController.activate(loadObject, false);
    }
  };

  componentWillUpdate = (nextProps, nextState) => {
    // console.log("FullEpgPersistance will update", nextProps, nextState);
  };

  componentDidUpdate = () => {
    // console.log("FullEpgPersistance did update");
  };

  componentWillUnmount = () => {
    PlayerControlsLogic.setValueStatePlaying({fullEPG: false});
    EpgController.deactivate();
    this.props.hideEpgOutside();
    // KeyInterceptor.destroy();
    // this.eventManager=null;
    logger.debug('[NEPG] will unmount');
  };

  shouldComponentUpdate(nextProps, nextState) {
    const cupdate = this.props.show !== nextProps.show;

    // console.log('[---PAU] shouldComponentUpdate en NEPG, render:  ', cupdate);

    return cupdate;
  }

  toggleContainer(hide) {
    const nepg = document.getElementById('fullepgcontainer');
    if (nepg) {
      if (hide && nepg.style.display === 'block') {
        nepg.style.display = 'none';
      }
      if (!hide && nepg.style.display === 'none') {
        nepg.style.display = 'block';
      }
    }
  }

  render() {
    // let epgStyle = this.props.show ? {display: 'block'} : {display: 'none'};
    const epgStyle = { display: 'block' };
    return <div id="fullepgcontainer" className={`FullEpgPersistanceWrapper ${Utils.playerEnableAnimation() ? 'text-focus-in': ''}`} style={epgStyle} />;
  }
}

FullEpgPersistance.propTypes = {
  // bla: PropTypes.string,
};

FullEpgPersistance.defaultProps = {
  // bla: 'test',
};

const mapDispatchToProps = {
  showPassEventNotAvailableNotification,
  showFutureEventNotAvailableNotification,
  playCatchupEvent
}

export default  connect(null, mapDispatchToProps)(FullEpgPersistance);



// WEBPACK FOOTER //
// ./src/components/FullEpgPersistance/FullEpgPersistance.js